import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiStepLabel: { styleOverrides: ComponentsOverrides<Theme>['MuiStepLabel'] } = {
    styleOverrides: {
        label: ({ theme }) => ({
            color: theme.palette.grey[700],
        }),
    },
};

export const MuiStepIcon: { styleOverrides: ComponentsOverrides<Theme>['MuiStepIcon'] } = {
    styleOverrides: {
        root: ({ theme }) => ({
            width: theme.spacing(3),
            height: theme.spacing(3),
            color: theme.palette.grey[400],
        }),
    },
};

export const MuiStepper: { styleOverrides: ComponentsOverrides<Theme>['MuiStepper'] } = {
    styleOverrides: {
        root: ({ theme }) => ({
            gap: theme.spacing(2),
        }),
    },
};

export const MuiStepConnector: { styleOverrides: ComponentsOverrides<Theme>['MuiStepConnector'] } = {
    styleOverrides: {
        root: ({ theme }) => ({
            maxWidth: theme.spacing(7),
        }),
    },
};
